import * as React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import Paper from "@mui/material/Paper";

export default function Footer() {
  return (
    <Container sx={{ py: 8 }} maxWidth="lg">
      <Grid container spacing={4}>
        <Grid item key="footer-links" xs={12} sm={12} md={6}>
          <Paper sx={{ p: 6 }} component="footer">
            <Typography
              variant="h6"
              align="center"
              fontWeight="bold"
              gutterBottom
            >
              Links
            </Typography>
            <Typography
              variant="subtitle1"
              align="center"
              color="text.secondary"
              component="div"
            >
              <p>
                <a href="https://discord.gg/4z6bf9sy44">Discord</a>
              </p>
              <p>
                <a href="https://map.mcverse.city/">Map</a>
              </p>
              <p>
                <a href="https://mcverse-store.tebex.io/category/2550414">
                  Store
                </a>
              </p>
            </Typography>
          </Paper>
        </Grid>

        <Grid item key="footer-disclaimer" xs={12} sm={12} md={6}>
          <Paper sx={{ p: 6 }} component="footer">
            <Typography variant="p" align="center" gutterBottom>
              Not an official Minecraft Service. <br />
              <br />
              Not approved by Mojang or Microsoft
            </Typography>
          </Paper>
        </Grid>

        <Grid item key="footer-store-banner" xs={12} sm={12} md={6}>
          <Paper
            sx={{
              p: 2,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: "100%",
            }}
            component="footer"
          >
            <Link
              href="https://mcverse-store.tebex.io/"
              target="_blank"
              rel="noopener noreferrer"
              sx={{ display: "block", lineHeight: 0 }}
            >
              <Box
                component="img"
                src="/imgs/mcv-2026-annual-rank-support-survival-minecraft.png"
                alt="MCV 2026 Annual Rank — Support the Server"
                sx={{
                  width: "100%",
                  maxWidth: 200,
                  height: "auto",
                  display: "block",
                }}
              />
            </Link>
          </Paper>
        </Grid>
        <Grid item key="footer-top-sites" xs={12} sm={12} md={6}>
          <Paper sx={{ p: 6 }} component="footer">
            <Typography
              variant="h6"
              align="center"
              fontWeight="bold"
              gutterBottom
            >
              Need support? Contact us
            </Typography>
            <Typography
              variant="subtitle1"
              align="center"
              color="text.secondary"
              component="div"
            >
              <p>
                <a href="https://discord.gg/4z6bf9sy44">Discord</a>
                <br />
                <br />
                <a href="mailto:mcversecity@outlook.com">Formal Email</a>
                <br />
                For support, business requests, ban appeals, and all other
                inquiries.
              </p>
            </Typography>
          </Paper>
        </Grid>
      </Grid>
    </Container>
  );
}
